import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import { featureFlagMiddleware } from "./middleware/featureFlagMiddleware";
import { logRocketMiddleware } from "./middleware/logRocketMiddleware";
import { patientAuthMiddleware } from "./middleware/patientAuthMiddleware";
import rootReducer from "./reducers";

const initialState = {};

const middleWare = [thunk, featureFlagMiddleware, logRocketMiddleware, patientAuthMiddleware];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleWare)),
);

export default store;
